import { Component, OnInit, Inject, ErrorHandler } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MatSelectChange } from '@angular/material';
import { ClickEvent } from 'angular-star-rating';
import { State } from '../state-view/state.model';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { IEntity } from '../models/entity.model';
import { Review } from '../models/review.model';
import { ReviewSummary } from '../models/review-summary.model';
import { ReviewSubrating } from '../models/review-subrating.model';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ImageUploadComponent } from '../image-upload/image-upload.component';


@Component({
  selector: 'app-write-review',
  templateUrl: './write-review.component.html',
  styleUrls: ['./write-review.component.scss']
})

export class WriteReviewComponent implements OnInit {
  initialEntity: IEntity;
  selectedEntity: IEntity;
  entities: Array<IEntity> = [];
  airportEntities: Array<IEntity> = [];
  FBOEntities: Array<IEntity> = [];
  businessEntities: Array<IEntity> = [];
  flyingClubEntities: Array<IEntity> = [];
  onClickResult: ClickEvent;
  currentReview: Review;
  ratingValue: number;
  reviewTitle: string;
  reviewText: string;
  state = State.Empty;
  airportEntity: IEntity;
  chosenEntity: IEntity;
  entitySelected: boolean;
  newReview = true;
  tempSubRatings: Array<ReviewSubrating>;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  writtenPhotoIds: Array<number> = [];
  newPhotoIds: Array<number> = [];

  constructor(
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<WriteReviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _auth: AuthService,
    private _userService: UserService,
    private _errorHandler: ErrorHandler,
    private _snackBar: MatSnackBar
    ) { }

  ngOnInit() {
    if (this.data.airport) {
      this.airportEntity = {
        id: this.data.airport.airportId,
        name: this.data.airport.name,
        type: 'Airport'
      };
      this.entities.push(this.airportEntity);
      this.airportEntities.push(this.airportEntity);
      this.initialEntity = this.airportEntity;
      this.selectedEntity = this.airportEntity;
      for (const currentBusiness of this.data.airport.businesses) {
        const currentEntity: IEntity = {
          id: currentBusiness.id,
          name: currentBusiness.name,
          type: 'Business'
        };
        this.entities.push(currentEntity);
        if (currentBusiness.isFbo) {
          this.FBOEntities.push(currentEntity);
        } else {
          this.businessEntities.push(currentEntity);
        }
      }
      this.FBOEntities.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      this.businessEntities.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      for (const currentBusiness of this.data.airport.flyingClubs) {
        const currentEntity: IEntity = {
          id: currentBusiness.id,
          name: currentBusiness.name,
          type: 'Flying Club'
        };
        this.entities.push(currentEntity);
        this.flyingClubEntities.push(currentEntity);
      }
      this.flyingClubEntities.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    } else if (this.data.business) {
      let businessEntity: IEntity;
      if (this.data.business.flyingClub && (this.data.business.flyingClub.clubAircraft || this.data.business.flyingClub.clubMembers)) {
        businessEntity = {
          id: this.data.business.id,
          name: this.data.business.name,
          type: 'Flying Club'
        };
        this.flyingClubEntities.push(businessEntity);
      } else {
        businessEntity = {
          id: this.data.business.id,
          name: this.data.business.name,
          type: 'Business'
        };
        if (this.data.business.isFbo) {
          this.FBOEntities.push(businessEntity);
        } else {
          this.businessEntities.push(businessEntity);
        }
      }
      this.entities.push(businessEntity);
      this.initialEntity = businessEntity;
      this.selectedEntity = businessEntity;
      for (const currentAirport of this.data.business.airports) {
        const currentEntity: IEntity = {
          id: currentAirport.airportId,
          name: currentAirport.name,
          type: 'Airport'
        };
        this.entities.push(currentEntity);
        this.airportEntities.push(currentEntity);
      }
      this.airportEntities.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }
    this.currentReview = this.data.userReview;
    if (this.currentReview && (this.currentReview.title || this.currentReview.review || this.currentReview.rating)) {
      this.newReview = false;
      if (this.data.airport) {
        this.data.airport.reviewSummary.avgSubRatings.forEach( (subRating) => {
          let found = false;
          this.currentReview.subRatings.forEach( (innerSubrating) => {
            if (innerSubrating.feature === subRating.feature) {
              found = true;
            }
          });
          if (!found) {
            const tempRating: ReviewSubrating = {
              feature: subRating.feature,
              rating: 0
            };
            this.currentReview.subRatings.push(tempRating);
          }
        });
        // this.currentReview.subRatings = JSON.parse(JSON.stringify(this.data.airport.reviewSummary.avgSubRatings));
      }
      if (this.data.business) {
        this.data.business.reviewSummary.avgSubRatings.forEach( (subRating) => {
          let found = false;
          this.currentReview.subRatings.forEach( (innerSubrating) => {
            if (innerSubrating.feature === subRating.feature) {
              found = true;
            }
          });
          if (!found) {
            const tempRating: ReviewSubrating = {
              feature: subRating.feature,
              rating: 0
            };
            this.currentReview.subRatings.push(tempRating);
          }
        });
        // this.currentReview.subRatings = JSON.parse(JSON.stringify(this.data.business.reviewSummary.avgSubRatings));
      }
      this.currentReview.subRatings.forEach((subRating) => {
        if (subRating.rating === null) {
          subRating.rating = 0;
        }
      });
    }
    this.chosenEntity = null;
    this.galleryOptions = [
      {
        width: '341px',
        // height: '255px', // for block with image preview
        height: '80px',
        thumbnailsColumns: 3,
        image: false, // remove to have image preview
        imageSize: 'contain',
        //  imageAnimation: NgxGalleryAnimation.Slide
        thumbnailsMargin: 5,
        thumbnailMargin: 5,
        imageArrowsAutoHide: true,
        thumbnailsArrowsAutoHide: true
      }
    ];

    if (this.data.userReview && this.data.userReview.galleryPhotos) {
      this.galleryImages = this.data.userReview.galleryPhotos;
    } else {
      this.galleryImages = [];
    }

    if (this.data.userReview && this.data.userReview.photos) {
      this.data.userReview.photos.forEach((photo) => {
        this.writtenPhotoIds.push(photo.photoId);
      });
    } else {
      this.writtenPhotoIds = [];
    }

    this.setFormValues();
  }

  setFormValues(entityLoaded: boolean = false) {
    if (!this.currentReview) {
      this.reviewText = '';
      this.reviewTitle = '';
      this.ratingValue = 0;
      if (this.data.airport) {
        this.tempSubRatings = JSON.parse(JSON.stringify(this.data.airport.reviewSummary.avgSubRatings));
        // deep copy array of objects by value
      } else if (this.data.business) {
        this.tempSubRatings = JSON.parse(JSON.stringify(this.data.business.reviewSummary.avgSubRatings));
        // deep copy array of objects by value
      }
      this.tempSubRatings.forEach( (subRating) => {
        subRating.rating = 0;
      });
      this.entitySelected = entityLoaded;
    } else {
      if (this.currentReview.review) {
        this.reviewText = this.currentReview.review;
      } else {
        this.reviewText = '';
      }
      if (this.currentReview.title) {
        this.reviewTitle = this.currentReview.title;
      } else {
        this.reviewTitle = '';
      }
      if (this.currentReview.rating) {
        this.ratingValue = this.currentReview.rating;
      } else {
        this.ratingValue = 0;
      }
      if (this.currentReview.subRatings && this.currentReview.subRatings.length > 0) {
        this.tempSubRatings = JSON.parse(JSON.stringify(this.currentReview.subRatings)); // deep copy array of objects by value
      } else {
        this.tempSubRatings = JSON.parse(JSON.stringify(this.data.business.reviewSummary.avgSubRatings));
      }
      // this.tempSubRatings = this.currentReview.subRatings;
      this.entitySelected = true;
    }
    this.tempSubRatings.forEach( (subRating) => {
      if (subRating.rating === null) {
        subRating.rating = 0;
      }
    });
  }

  onRatingClick = ($event: ClickEvent) => {
    this.onClickResult = $event;
    // this.writeRating($event);
    this.ratingValue = $event.rating;
  }

  onSubRatingClick = ($event: ClickEvent, index: number) => {
    this.onClickResult = $event;
    this.tempSubRatings[index].rating = $event.rating;
  }

  selectChange = ($event: MatSelectChange) => {
    this.entityChange();
  }

  selectEntity() {
    this.entitySelected = true;
    this.selectedEntity = this.chosenEntity;
    this.entityChange();
  }

  resetChosen() {
    this.entitySelected = false;
    this.currentReview = null;
  }

  submitForm(value: any) {
    this.writeReview(value);
    // this.dialogRef.close();
  }

  async entityChange() {
    try {
      this.currentReview = await this._userService.getUserReview(this.selectedEntity);
      this.setFormValues(true);
    } catch (e) {
      this._errorHandler.handleError(e);
    }
  }

  async writeReview(v) {
    if (!this._auth.authenticated || !this._auth.endUser) {
      this._auth.redirectToLogin();
      return;
    }
    const workingReview = new Review();
    const snackBarOpts = { duration: 2000 };
    this.state = State.Loading;
    // create a new review object if the user hasn't rated this entity
    /* if (!this.currentReview) {
      this.currentReview = new Review();
      newRow = true;
    }
    this.currentReview.review = v.reviewField;
    this.currentReview.title = this.reviewTitle;
    this.currentReview.rating = this.ratingValue;
    if (this.currentReview.rating === 0) {
      this._snackBar.open(`Overall rating required.`, 'Dismiss', { duration: 5000 });
      return;
      // this.currentReview.rating = null;
    }
    console.log(this.tempSubRatings);
    this.currentReview.subRatings = [];
    this.tempSubRatings.forEach( (subRating) => {
      if (subRating.rating > 0) {
        console.log(subRating);
        this.currentReview.subRatings.push(subRating);
      }
    });
    console.log(this.currentReview); */
    workingReview.review = v.reviewField;
    workingReview.title = this.reviewTitle;
    workingReview.rating = this.ratingValue;
    if (workingReview.rating === 0) {
      this._snackBar.open(`Overall rating required.`, 'Dismiss', { duration: 5000 });
      return;
      // this.currentReview.rating = null;
    }
    workingReview.subRatings = [];
    this.tempSubRatings.forEach( (subRating) => {
      if (subRating.rating > 0) {
        workingReview.subRatings.push(subRating);
      }
    });
    // this.currentReview.subRatings = JSON.parse(JSON.stringify(this.tempSubRatings)); // deep copy array of objects by value
    /* this.currentReview.subRatings.forEach( (subRating) => {
      if (subRating.rating === 0) {
        subRating.rating = null;
      }
    }); */

    try {
      let review: any = null;
      if (this.newReview) {
        review = await this._userService.postReview(workingReview, this.selectedEntity);
      } else {
        review = await this._userService.putReview(this.currentReview.id, workingReview, this.selectedEntity);
      }
      this.newPhotoIds.forEach( async (photoId) => {
        const photo = await this._userService.putReviewPhoto(review.id, photoId, this.selectedEntity);
      });
      this._snackBar.open(`Review saved.`, 'Dismiss', snackBarOpts);
      let businessId = -1;
      if (this.selectedEntity.type === 'Business') {
        businessId = this.selectedEntity.id;
      }
      this.dialogRef.close({success: true, newPhotoIds: this.newPhotoIds, businessId: businessId });
    } catch (e) {
      let errorMessage = 'An error occurred saving your review. Please try again later.';
      if (e.error.message === 'A review already exists for this customer.') {
        errorMessage = e.error.message;
      }
      this._snackBar.open(errorMessage, 'Dismiss', snackBarOpts);
      this._errorHandler.handleError(e);

      // Set state to error, then reset after a few seconds to allow retry.
      this.state = State.Error;
      setTimeout(() => {
        this.state = State.Content;
      }, 2000);

      this.dialogRef.close({success: true});
    }
  }

  async deleteImage(index: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: 'Delete this image?'
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        // if user confirmed delete
        const snackBarOpts = {duration: 2000};
        try {
          // const review = await this._userService.deleteReviewPhoto(this.currentReview.photos[index].photoId, this.selectedEntity.type);
          // this.currentReview.photos.splice(index, 1);
          if (index < this.writtenPhotoIds.length) {
            const review = await this._userService.deleteReviewPhoto(this.writtenPhotoIds[index], this.selectedEntity.type);
            this.writtenPhotoIds.splice(index, 1);
          } else {
            this.newPhotoIds.splice(index, 1);
          }
          this.galleryImages.splice(index, 1);
        } catch (e) {
          this._snackBar.open('An error occurred deleting the image. Please try again later.', 'Dismiss', snackBarOpts);
          this._errorHandler.handleError(e);

          // Set state to error, then reset after a few seconds to allow retry.
          this.state = State.Error;
          setTimeout(() => {
            this.state = State.Content;
          }, 2000);
        }
      }
    });
  }

  async openAddImageDialog() {
    const dialogRef = this.dialog.open(ImageUploadComponent, {
      width: '500px',
      data: { images: this.galleryImages, entity: this.selectedEntity, newPhotoIds: this.newPhotoIds }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        // if user confirmed delete
        const snackBarOpts = {duration: 2000};
        try {
          /* this.newPhotoIds.forEach((photoId) => {
            if (!this.writtenPhotoIds.includes(photoId)) {
              this.writtenPhotoIds.push(photoId);
            }
          }); */
          // console.log('addImage: ', this.newPhotoIds);
        } catch (e) {
          this._snackBar.open('An error occurred deleting the review. Please try again later.', 'Dismiss', snackBarOpts);
          this._errorHandler.handleError(e);

          // Set state to error, then reset after a few seconds to allow retry.
          this.state = State.Error;
          setTimeout(() => {
            this.state = State.Content;
          }, 2000);
        }
      }
    });
  }

  cancel () {
    this.galleryImages.splice(this.galleryImages.length - this.newPhotoIds.length, this.newPhotoIds.length);
    this.dialogRef.close({success: false, newPhotoIds: []});
  }
}
